import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("velvet_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imgSrc = (item) =>
  item.image_url ? item.image_url : `${API}/files/${item.storage_path}`;

export const formatApiError = (err, fallback = "Something went wrong. Please try again.") => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return fallback;
};
